<mat-card>
  <app-card-header
    [title]="title"
    icono="verified"
    [draggable]="!!dialogRef"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  @if (loading) {
    <mat-card-content class="card-content-crear">
      <div class="loading-container">
        <mat-spinner diameter="48"></mat-spinner>
        <p>Cargando...</p>
      </div>
    </mat-card-content>
  }

  @if (!loading && form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <mat-card-content class="card-content-crear">
        <!-- Información del Certificado -->
        <app-content-card title="Información del certificado" icon="info">
          <div class="info-row">
            <span class="info-label">Entidad:</span>
            <span class="info-value">{{ getEntidadInfo() }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Tipo:</span>
            <span class="info-value">Certificado Manual</span>
          </div>
          @if (certificado?.fechaComienzo) {
            <div class="info-row">
              <span class="info-label">Fecha de Inicio:</span>
              <span class="info-value">
                {{ certificado.fechaComienzo | date: 'dd/MM/yyyy HH:mm' }}
              </span>
            </div>
          }
        </app-content-card>

        <!-- Lista de Códigos -->
        <app-content-card
          title="Códigos disponibles"
          icon="integration_instructions"
          [subtitle]="
            getCodigosSeleccionados().length +
            ' de ' +
            codigosDisponibles.length +
            ' seleccionados'
          "
        >
          <!-- Selección de Todos -->
          @if (codigosDisponibles.length > 0) {
            <div class="select-all-section">
              <mat-checkbox
                [checked]="todosSeleccionados"
                (change)="toggleTodos()"
                color="primary"
              >
                <strong>Seleccionar todos los códigos</strong>
              </mat-checkbox>
            </div>
          }

          @if (codigosDisponibles.length === 0) {
            <div class="empty-state">
              <mat-icon>inbox</mat-icon>
              <p>No hay códigos disponibles para esta entidad</p>
            </div>
          }

          @if (codigosDisponibles.length > 0) {
            <div class="codigos-list">
              @for (codigo of codigosDisponibles; track codigo.codigo) {
                <div
                  class="codigo-item irx-clickeable"
                  role="button"
                  tabindex="0"
                  [class.selected]="codigo.seleccionado"
                  (click)="toggleSeleccionCodigo(codigo)"
                  (keydown.enter)="toggleSeleccionCodigo(codigo)"
                >
                  <mat-checkbox
                    [checked]="codigo.seleccionado"
                    color="primary"
                    (click)="$event.stopPropagation()"
                    (change)="toggleSeleccionCodigo(codigo)"
                  ></mat-checkbox>

                  <div class="codigo-info">
                    <div class="codigo-header">
                      <span class="codigo-value">{{ codigo.codigo }}</span>
                      @if (codigo.test) {
                        <mat-chip class="codigo-chip test-chip">Test</mat-chip>
                      }
                      @if (codigo.armado) {
                        <mat-chip class="codigo-chip armado-chip">
                          Armado
                        </mat-chip>
                      }
                      @if (codigo.desarmado) {
                        <mat-chip class="codigo-chip desarmado-chip">
                          Desarmado
                        </mat-chip>
                      }
                    </div>
                    @if (codigo.descripcion) {
                      <p class="codigo-descripcion">{{ codigo.descripcion }}</p>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </app-content-card>
      </mat-card-content>

      <!-- Acciones -->
      <mat-card-actions class="actions-create">
        <button irxBoton="secundario" type="button" (click)="cerrar()">
          Cancelar
        </button>
        <button
          irxBoton="principal"
          type="submit"
          [disabled]="getCodigosSeleccionados().length === 0 || loading"
        >
          <mat-icon>save</mat-icon>
          Guardar
        </button>
      </mat-card-actions>
    </form>
  }
</mat-card>
